<!--
  Geometry copied from the Pin Manager panel so the two feel like the same
  thing: fixed to the right under the nav bar, slid in with a transform rather
  than a width change, which does not reflow the table behind it.
-->
<div class="fixed right-0 top-[56px] bottom-0 w-[360px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.08)] z-[850] transition-transform duration-300 flex flex-col overflow-hidden"
     [class.translate-x-full]="!open"
     [class.translate-x-0]="open">

  <!-- Header -->
  <div class="border-t-[3px] border-t-[var(--primary-dark)]">
    <div class="flex items-center gap-2 py-4 px-5 border-b border-[var(--app-base)]">
      <span class="material-icons text-[var(--primary-dark)] text-[18px]">call_merge</span>
      <span class="text-[14px] font-semibold flex-1 leading-none text-[var(--base-text-alt-dark)]">Merged Samples</span>
      <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
            (click)="closed.emit()">close</span>
    </div>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto p-5" *ngIf="group">

    <!-- What the merge actually does, which differs by screen. -->
    <p class="text-[13px] leading-relaxed text-[var(--tertiary-text)] m-0 mb-4">{{ group.explanation }}</p>

    <!--
      Called out rather than left to be noticed in the list. One set of lab
      values driving several blocks is a judgement the agronomist should be
      making deliberately, not discovering.
    -->
    <div *ngIf="group.crossField"
         class="flex items-start gap-2 p-3 mb-4 rounded-lg bg-[var(--app-base)]">
      <span class="material-icons text-[16px] text-[var(--notification-warning)] mt-px">info</span>
      <span class="text-[12px] leading-snug text-[var(--base-text-alt-dark)]">
        This group covers {{ group.fieldNames.join(', ') }}. One set of lab values drives all of them.
      </span>
    </div>

    <div class="text-[11px] font-bold uppercase tracking-wider text-[var(--tertiary-text)] mb-1">
      {{ group.members.length }} samples in this group
    </div>

    <div *ngFor="let member of group.members"
         class="flex items-start gap-2.5 py-3 border-b border-[var(--app-base)] last:border-b-0">

      <span *ngIf="member.isPrimary"
            class="material-icons text-[16px] mt-0.5 text-[var(--primary-dark)]">science</span>
      <span *ngIf="!member.isPrimary"
            class="material-icons text-[16px] mt-0.5 text-[var(--tertiary-text)]">subdirectory_arrow_right</span>

      <div class="flex-1 min-w-0">
        <div class="text-[13px] font-semibold text-[var(--base-text-alt-dark)] break-words">{{ member.sampleName }}</div>
        <div class="text-[11px] text-[var(--tertiary-text)] break-words">
          <!-- No field is a real state: a pin is allowed to have none. Said
               plainly rather than left as an empty line. -->
          {{ member.fieldName || 'No field' }}<span *ngIf="member.farmName"> &middot; {{ member.farmName }}</span>
        </div>
      </div>

      <span *ngIf="member.isPrimary"
            class="shrink-0 text-[10px] font-bold uppercase tracking-wider text-[var(--primary-dark)] border border-[var(--primary-dark)] rounded px-1.5 py-0.5">Primary</span>

      <!--
        Members only. Removing the primary would leave a group with nothing
        measuring it, so choosing a new one is a separate decision and a
        separate feature.

        No confirmation. This is only offered while the submission is still
        editable, so nothing has been measured yet: the sample goes back to
        standing on its own and merging again restores it.
      -->
      <span *ngIf="canUnmerge && !member.isPrimary"
            (click)="removeMember(member)"
            [title]="'Take ' + member.sampleName + ' out of this group'"
            class="shrink-0 material-icons text-[18px] cursor-pointer rounded-full w-7 h-7 flex items-center justify-center text-[var(--tertiary-text)] hover:bg-[var(--app-base)] hover:text-[var(--notification-error)] transition-colors"
            [class.opacity-40]="pending != null"
            [class.pointer-events-none]="pending != null">call_split</span>
    </div>
  </div>
</div>
